import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar.component';
import { FormsModule } from '@angular/forms';
import { NotificationTypePipe } from '../../services/pipes/notification-type.pipe';

@NgModule({
    imports: [RouterModule, CommonModule , FormsModule],
    declarations: [NavbarComponent,
        NotificationTypePipe],
    exports: [NavbarComponent,
        NotificationTypePipe]
})

export class NavbarModule { }



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/shared/navbar/navbar.module.ts